import 'codemirror/addon/edit/closebrackets'
import 'codemirror/addon/edit/closetag'
import 'codemirror/addon/selection/active-line'
import 'codemirror/mode/meta'
import 'codemirror/mode/htmlmixed/htmlmixed'
import codeMirror from 'codemirror/lib/codemirror'

import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/railscasts.css'

window.CodeMirror = codeMirror

export default codeMirror
